import { useCallback, useState } from "react";
import { useUnmount } from "react-use";
import { createSelectedRowKey } from "../../modules/samples/util";

/**
 * Hook to handle grid with expandable rows
 * @param page number - current page
 */
function useExpandableRowsGrid(page: number) {
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});

  const handleCheckRowExpanded = (_row: unknown, index: number): boolean => {
    const key = createSelectedRowKey(index, page, _row);
    return expandedRows[key];
  };

  const handleRowExpandedChange = (
    isExpanded: boolean,
    _item: unknown,
    index: number
  ) => {
    const key = createSelectedRowKey(index, page, _item);
    setExpandedRows(prev => ({
      ...prev,
      [key]: isExpanded
    }));
  };

  const resetExpandedRows = useCallback(() => {
    setExpandedRows({});
  }, []);

  useUnmount(() => {
    resetExpandedRows();
  });

  return {
    expandedRows,
    handleCheckRowExpanded,
    handleRowExpandedChange,
    resetExpandedRows
  };
}

export default useExpandableRowsGrid;
